var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcChallenge = function SvgIcChallenge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.82 2.791a1.25 1.25 0 0 1 .886 1.53L4.101 21.653a1.25 1.25 0 1 1-2.416-.642L6.29 3.678a1.25 1.25 0 0 1 1.53-.887",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.435 5.478 1.734 2.106a3.93 3.93 0 0 0 2.561 1.402 3.93 3.93 0 0 1 2.93 1.935l.666 1.152a4 4 0 0 0 2.428 1.864l1.78.477-3.083 2.588c-.927.778-2.273.8-3.224.05a2.56 2.56 0 0 0-2.858-.204l-.645.372a3.655 3.655 0 0 1-4.088-.293l-1.048-.824z"
  })));
};
export default SvgIcChallenge;